const getPaymentTypes = () => {
  return {
    online: 'Оплачено',
    office: 'В офисе'
  }
}

export default getPaymentTypes;
